<template>
  <Header/>
  <div class="wrap">
    <loading
        :active="isLoading"
        :background-color="bgColor"
        :can-cancel="canCancel"
        :color="color"
        :height="height"
        :is-full-page="fullPage"
        :loader="loader"
        :opacity="opacity"
        :width="width"
    />
    <Menu/>

    <div class="wrapper">
      <div id="btnGo" class="btn_go_area" style="position: relative">
        <button id="btnGoRight" class="btn_go right" @click="scrollToEnd()"></button>
        <button id="btnGoLeft" class="btn_go left" @click="scrollToFirst()"></button>
      </div>
      <router-view :key="$route.fullPath" :log-scroll-position="logScrollPosition"/>
    </div>
  </div>
  <Footer/>
  <!-- 공통 alert -->
  <div class="popup sm" data-popup-common>
    <div class="ct">
      <p>정상 승인 처리되었습니다</p>
    </div>
    <div class="ft">
      <div class="btn_wrap">
        <button class="btn md_100p purple" data-popup-del type="button">확인</button>
      </div>
    </div>
  </div>

  <div class="popup sm open_source" data-popup-open-source>
    <div class="hd">
      <h5 class="tit">Open Source S/W License Notice</h5>
    </div>
    <div class="ct text_left">
      <p>This product contains the following Open Source Software with licenses and notices below. For any questions,
        please contact to market.ktcloud@kt.com</p>
      <p>GNU LESSER GENERAL PUBLIC LICENSE</p>
      <a href="https://www.tiny.cloud/docs-3x/extras/TinyMCE3x@License/" target="_blank">https://www.tiny.cloud/docs-3x/extras/TinyMCE3x@License/</a>
      <p class="small">Version 2.1</p>
    </div>
    <div class="ft">
      <div class="btn_wrap">
        <button class="btn md_100p purple" data-popup-open-source-del type="button">닫기</button>
      </div>
    </div>
  </div>

  <div class="popup md" data-popup-confirm>
    <div class="ct">
      <p></p>
    </div>
    <div class="ft">
      <div class="btn_wrap">
        <button class="btn md_190 light" data-popup-cancleBtn type="button">취소</button>
        <button class="btn md_190 purple" data-popup-confirmBtn type="button">확인</button>
      </div>
    </div>
  </div>

  <div class="dim"></div>
  <GlobalEvents @click="globalClick" @keydown="globalClick" @contextmenu.prevent="globalClick"></GlobalEvents>

  <div class="popup md logoutPopup" data-popup-logout>
    <div class="hd">
      <h5 class="tit">자동 로그아웃</h5>
    </div>
    <div class="ct">
      <p>계정 인증 보호를 위하여 곧 자동 로그아웃 됩니다.<br>
        로그인 상태를 유지하시겠습니까?</p>
      <div>
        <span>{{ timeCount }}</span>
      </div>
    </div>
    <div class="ft">
      <div class="btn_wrap">
        <button class="btn md_190 light" data-popup-cancleBtn2 type="button">로그 아웃</button>
        <button class="btn md_190 purple" data-popup-confirmBtn2 type="button">로그인 유지</button>
      </div>
    </div>
  </div>
</template>
<style scoped>
.popup.md .ct p {
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: bold;
}
</style>
<script>
import {computed, inject, onBeforeUnmount, onMounted, reactive, toRefs} from "vue";
import {useRouter} from 'vue-router'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Header from "./views/common/Header";
import Footer from "./views/common/Footer";
import Menu from "./views/common/Menu";
import {useStore} from "vuex";
import commonMgt from "@/assets/js/marketPartnerCommon.js";
import {GlobalEvents} from "vue-global-events";
import moment from "moment";

export default {
  name: 'App',
  components: {Header, Loading, Menu, Footer, GlobalEvents, moment},
  setup: () => {
    const {common} = commonMgt();
    const emitter = inject("emitter");
    const router = useRouter();
    const store = useStore();

    const sessionTimeOutSecond = 600;

    const state = reactive({
      authorization: computed(() => store.getters["staLogin/getPartnerAccessToken"]),
      isLoading: false,
      canCancel: true,
      fullPage: true,
      height: 128,
      width: 128,
      color: "#f8595b",
      loader: "spinner", // bars, dots
      opacity: 0.1,
      bgColor: "#ffffff",
      isLogin: false,
      timeLimit: 3600,
      timeCount: "",
      polling: "",
      logoutPop: false
    });

    emitter.on("myevent", value => state.isLoading = value);
    emitter.on("myLogin", (value) => {
      state.isLogin = value;
    });
    emitter.on("log-scroll-position", () => {
      window.addEventListener('resize', checkScroll);
      document.addEventListener('DOMContentLoaded', checkScroll);
      document.addEventListener('DOMContentLoaded', logScrollPosition);
      window.addEventListener('scroll', logScrollPosition);
      if (document.getElementById('scrollContainer') !== null) {
        document.getElementById('scrollContainer').addEventListener('scroll', logScrollPosition);
      }
    })

    emitter.on("isLogin", (value) => {
      if (value) {
        state.logoutPop = false;
        state.timeLimit = 3600;
        clearInterval(state.polling);
        start();
      } else {
        clearInterval(state.polling);
      }
    });

      emitter.on("logoutPopupOpen", () => {
          console.log("logoutPopupOpen");
          state.timeLimit = 300;
      });

    onMounted(() => {
      $("#loading").removeClass("active");
      var authorization = store.getters["staLogin/getPartnerAccessToken"];
      if (!common.isEmpty(authorization)) {
        state.isLogin = true;
        state.logoutPop = false;
        clearInterval(state.polling);
        start();
      }
      window.addEventListener('resize', checkScroll);
      document.addEventListener('DOMContentLoaded', checkScroll);
      document.addEventListener('DOMContentLoaded', logScrollPosition);
      window.addEventListener('scroll', logScrollPosition);
      if (document.getElementById('scrollContainer') !== null) {
        document.getElementById('scrollContainer').addEventListener('scroll', logScrollPosition);
      }
    });


    onBeforeUnmount(() => {
      if (document.getElementById('scrollContainer') !== null) {
        document.getElementById('scrollContainer').addEventListener('scroll', logScrollPosition);
      }
    });

    const evtLogout = () => {
      document.querySelector('.dim').style.display = "none";
      document.querySelector('.logoutPopup').style.display = "none";
      clearInterval(state.polling);
      router.push({name: 'Login'});
    };

    function start() {
      state.polling = setInterval(() => {
        //10 minutes

        const logoutTime = store.getters["staLogin/getLoginChekcTime"];
        const today = moment()
        const time = moment(logoutTime, 'YYYYMMDDHHmmss')

        const count = moment.duration(time.diff(today)).minutes()
        try {
          if (count <= 0) {
            //세션x
            if (state.isLogin) {
              evtLogout();
            }
          }
          if (!common.isEmpty(store.getters["staLogin/getPartnerAccessToken"])) {
            if (count <= 10) {
              if (state.isLogin) {
                if (state.timeLimit > 600 && state.logoutPop == false) {
                  state.timeLimit = 300;
                }
              }
            }
          }
        } catch (e) {
          console.log(e);
        }
        state.timeLimit--; //1씩 감소
        state.timeCount = prettyTime();
        if (state.timeLimit <= 300 && state.logoutPop == false) {
          store.commit("staLogin/setLoginPopup", false);
          state.logoutPop = true
          popup_logout(common.tokenRefresh, evtLogout);
        }
        if (state.timeLimit == 0) {
          store.commit("staLogin/setLoginPopup", true);
          evtLogout();
        }
      }, 1000);
    }

    function prettyTime() {
      let time = state.timeLimit / 60;
      let minutes = parseInt(time);
      let secondes = Math.round((time - minutes) * 60);
      return pad(minutes, 2) + ":" + pad(secondes, 2);
    }

    function pad(n, width) {
      n = n + "";
      return n.length >= width
          ? n
          : new Array(width - n.length + 1).join("0") + n;
    }

    function globalClick() {
      if (state.isLogin) {
        state.logoutPop = false;
        clearInterval(state.polling);
        start();
      } else {
        clearInterval(state.polling);
      }
    }

    function scrollToEnd() {
      var container = document.getElementById('scrollContainer');

      if (container !== null) {
        container.scrollTo({
          left: container.scrollWidth,
          behavior: 'smooth'
        });
      }

      window.scrollTo({
        left: document.documentElement.scrollWidth,
        behavior: 'smooth'
      });
    }


    function scrollToFirst() {
      var container = document.getElementById('scrollContainer');

      if (container !== null) {
        container.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      }

      window.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    }

    function checkScroll() {
      var btnGo = document.getElementById('btnGo');
      var container = document.getElementById('scrollContainer');
      var containerScrollable;
      if (container !== null) {
        containerScrollable = container.scrollWidth > container.clientWidth;
      }
      var documentScrollable = document.documentElement.scrollWidth > document.documentElement.clientWidth;
      if (!common.isEmpty(containerScrollable) || documentScrollable) {
        btnGo.style.display = 'block';
      } else {
        btnGo.style.display = 'none';
      }
    }

    function logScrollPosition() {

      var btnGoRight = document.getElementById('btnGoRight');
      var btnGoLeft = document.getElementById('btnGoLeft');
      var container = document.getElementById('scrollContainer');
      if (container !== null) {
        var containerScrollRightEdge = container.scrollLeft + container.clientWidth;
        var containerContentWidth = container.scrollWidth;

        var documentScrollRightEdge = window.pageXOffset + document.documentElement.clientWidth;
        var documentContentWidth = document.documentElement.scrollWidth;

        // 맨 오른쪽에 도달했을 때 btnGoRight를 숨기고, 맨 왼쪽에 도달했을 때 btnGoLeft를 숨김
        if (container.scrollLeft === 0 && window.pageXOffset === 0) {
          // 왼쪽 끝에 도달한 경우: btnGoLeft 숨기고 btnGoRight 표시
          btnGoLeft.style.display = 'none';
          btnGoRight.style.display = 'block';
        } else if (containerContentWidth <= containerScrollRightEdge && documentContentWidth <= documentScrollRightEdge) {
          // 오른쪽 끝에 도달한 경우: btnGoRight 숨기고 btnGoLeft 표시
          btnGoRight.style.display = 'none';
          btnGoLeft.style.display = 'block';
        } else {
          // 중간 위치: 두 버튼 모두 표시
          btnGoRight.style.display = 'block';
          btnGoLeft.style.display = 'block';
        }
      } else {
        btnGoRight.style.display = 'none';
        btnGoLeft.style.display = 'none';
      }
    }

    return {
      ...toRefs(state),
      start,
      evtLogout,
      globalClick,
      scrollToEnd,
      scrollToFirst,
      checkScroll,
      logScrollPosition
    }
  }
}
</script>